import axios from 'axios';
import connection from './connection';
import { IndentDropdownResponse, IndentAckResponse, IndentModel, AllIndentsResponseModel, IndentRequest, UpdateVehStatusRequest, GrnStatusUpdate, GrnCompletedStatusResponse, IndentQuantityRequest, IndentQtyResponse, GetHarvestingResponseModel, PlantRequest, IndentRtRequest, IndentReportResponse, HarvestReportResponse, HarvestModel, HarvestIdRequest, IndentDetailsModel, IndentResponseModel, AllIndentReportResponse, IndentAbstractRequest, RmCountReq, IndentHarvestingDateReq, indentIdReq } from '@gtpl/shared-models/raw-material-procurement';
import { CommonResponse } from '@gtpl/shared-models/masters';
import {CommonResponse as Response} from 'libs/shared-models/sale-management/src'

export class IndentService {
    URL = connection.DEPLOY_URL + '/indent';
    // userid = connection.userid;
    // role=connection.role;
    // unitId=connection.unit_id;

    async createIndent(indentModel: IndentDetailsModel): Promise<IndentResponseModel> {
        return await axios.post(this.URL + '/createIndent', indentModel)
            .then(res => {
                return res.data
            })
    }

    async updateIndent(indentModel: IndentDetailsModel): Promise<IndentResponseModel> {
        return await axios.post(this.URL + '/updateIndent', indentModel)
            .then(res => {
                return res.data
            })
    }


    async getAllIndents(req?:any): Promise<AllIndentsResponseModel> {
        return await axios.post(this.URL + '/getAllIndents',req
            // {headers: { "userid" : this.userid,"role":this.role,"unit_id":this.unitId}}
        )
            .then(res => {
                return res.data
            })
    }

    async getCompletedIndents(req?:any): Promise<AllIndentsResponseModel> {
        return await axios.post(this.URL + '/getClosedIndents',req
            // {headers: { "userid" : this.userid,"role":this.role,"unit_id":this.unitId}}
        )
            .then(res => {
                return res.data
            })
    }
    async getIndentsForDropdown(): Promise<IndentDropdownResponse> {
        return await axios.post(this.URL + '/getIndentsForDropdown')
            .then(res => {
                return res.data
            })
    }
    async getIndentDetailsById(indentIdReq: IndentRequest): Promise<IndentAckResponse> {
        return await axios.post(this.URL + '/getIndentDetailsById', indentIdReq)
            .then(res => {
                return res.data
            })
    }
    async updateVehicleStatus(updateVehStatusRequest: UpdateVehStatusRequest): Promise<any> {
        return await axios.post(this.URL + '/updateVehicleStatus', updateVehStatusRequest)
            .then(res => {
                return res.data
            })
    }

    async updateGrnCompletedStatus(grnInfo: GrnStatusUpdate): Promise<GrnCompletedStatusResponse> {
        return await axios.post(this.URL + '/updateGrnCompletedStatus', grnInfo)
            .then(res => {
                return res.data
            })
    }

    async activateOrDeactivateIndent(indentModel: IndentModel): Promise<IndentAckResponse> {
        return await axios.post(this.URL + '/activateOrDeactivateIndent', indentModel)
            .then(res => {
                return res.data
            })
    }

    async getProductCountWiseIndentQty(inputReq: IndentQuantityRequest): Promise<IndentQtyResponse> {
        return await axios.post(this.URL + '/getProductCountWiseIndentQty', inputReq)
            .then(res => {
                return res.data
            })
    }
    async getIndentQty(): Promise<IndentQtyResponse> {
        return await axios.post(this.URL + '/getIndentQty')
            .then(res => {
                return res.data
            })
    }

    async getPendingGrnQty(): Promise<IndentQtyResponse> {
        return await axios.post(this.URL + '/getPendingGrnQty')
            .then(res => {
                return res.data
            })
    }


    async getHarvestinData(inputReq: PlantRequest): Promise<GetHarvestingResponseModel> {
        return await axios.post(this.URL + '/getHarvestinData', inputReq)
            .then(res => {
                return res.data
            })
    }
    async cancelAssignedVehicle(inputReq: IndentModel): Promise<CommonResponse> {
        return await axios.post(this.URL + '/cancelAssignedVehicle', inputReq)
            .then(res => {
                return res.data
            })
    }

    async getIndentReportDetails(inputReq: IndentRtRequest): Promise<AllIndentReportResponse> {
        return await axios.post(this.URL + '/getIndentReportDetails', inputReq)
            .then(res => {
                return res.data
            })
    }


    async createHarvestReport(inputReq: HarvestModel): Promise<HarvestReportResponse> {
        return await axios.post(this.URL + '/createHarvestReport', inputReq)
            .then(res => {
                return res.data
            })
    }

    async getHarvestReport(inputReq: HarvestIdRequest): Promise<HarvestReportResponse> {
        return await axios.post(this.URL + '/getHarvestReport', inputReq)
            .then(res => {
                return res.data
            })
    }
    async getIndentDataById(inputReq: IndentRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getIndentDataById', inputReq)
            .then(res => {
                return res.data
            })
    }

    async getIndentItemDataById(req: indentIdReq): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getIndentItemDataById', req)
            .then(res => {
                return res.data
            })
    }

    async openOrCloseGrn(inputReq: IndentRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/openOrCloseGrn', inputReq)
            .then(res => {
                return res.data
            })
    }

    async getIndentAbstract(inputReq: IndentAbstractRequest): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getIndentAbstract',inputReq)
            .then(res => {
                return res.data
            })
     }

     async getRmRateAgainstCount(inputReq: RmCountReq): Promise<CommonResponse>{
        return await axios.post(this.URL + '/getRmRateAgainstCount',inputReq)
            .then(res => {
                return res.data
            })
     }

     async getCancelledIndents(req?:any): Promise<AllIndentsResponseModel> {
        return await axios.post(this.URL + '/getCancelledIndents',req
            // {headers: { "userid" : this.userid,"role":this.role,"unit_id":this.unitId}}
        )
            .then(res => {
                return res.data
            })
    }
    async CancelIndent(req:IndentRequest): Promise<AllIndentsResponseModel> {
        return await axios.post(this.URL + '/CancelIndent',req
            // {headers: { "userid" : this.userid,"role":this.role,"unit_id":this.unitId}}
        )
            .then(res => {
                return res.data
            })
    }
    async getBookingArrivalsData(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getBookingArrivalsData'
            // {headers: { "userid" : this.userid,"role":this.role,"unit_id":this.unitId}}
        )
            .then(res => {
                return res.data
            })
    }
    async getCountWiseProcurementData(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getCountWiseProcurementData'
            // {headers: { "userid" : this.userid,"role":this.role,"unit_id":this.unitId}}
        )
            .then(res => {
                return res.data
            })
    }
    async getRmRatesGraphData(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRmRatesGraphData'
            // {headers: { "userid" : this.userid,"role":this.role,"unit_id":this.unitId}}
        )
            .then(res => {
                return res.data
            })
    }
}


